import {
    Component,
    OnInit,
    AfterViewInit,
    OnDestroy,
    ChangeDetectorRef,
    HostListener
} from "@angular/core";
import { LoaderService } from "../../services";

@Component({
    selector: "app-loader",
    templateUrl: "./loader.component.html",
    standalone: false
})
export class LoaderComponent implements OnInit, AfterViewInit, OnDestroy {
    _loader: any;
    message: any = "";
    addDots: boolean = true;
    overlayActive: boolean = false; // Tracks immediate overlay state


    @HostListener("window:keydown", ["$event"])
    keyEventAlt(event: KeyboardEvent) {
        // Block keyboard events if either overlay is active or loader is visible
        if (this._loader || this.overlayActive) {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();
        }
    }

    constructor(
        private loaderService: LoaderService,
        private _cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.loaderService
            .getMessage()
            .subscribe(loader =>{
                    this._loader = loader;
                    this._cdr.detectChanges();
                });
        this.loaderService
            .getLoaderMessage()
            .subscribe(message =>
                {
                    if (message?.includes(" ..."))  this.addDots = false;
                    this.message = message
                }
                );
        // Subscribe to overlay state
        this.loaderService
            .getOverlay()
            .subscribe(overlay => {
                this.overlayActive = overlay;
                this._cdr.detectChanges();
            });
    }
    ngAfterViewInit() {
        this._cdr.markForCheck();
    }
    ngOnChanges() {
        this._cdr.detectChanges();
    }
    ngOnDestroy() {
        this._cdr.detach();
    }
   
}
